import { FULL_HD, HD } from '@bedrock-rdk/constants';

export const logoOptions = {
  [HD]: {
    width: 251,
    height: 141,
  },
  [FULL_HD]: {
    width: 382,
    height: 215,
  },
};
